import React, { FC } from 'react';
import Link from '@app/components/Link';
import { FormattedMessage } from 'react-intl';
import { Text } from '@rebass/emotion';

import Checkmark from '@app/components/Checkmark';

import { Circle, Label, StepLine, StepDot } from './Step.styles';
import { StepState } from './StepsProgress.types';

const Step: FC<{ stepState: StepState }> = ({ stepState }) => (
  <>
    <StepDot>
      {stepState.isPassed ? (
        <Link
          to={stepState.step.route}
          data-testid={`steps-progress-step-link-${stepState.stepNumber}`}
        >
          <Circle stepState={stepState}>
            <Checkmark color="white" />
          </Circle>
        </Link>
      ) : (
        <Circle stepState={stepState}>
          <Text fontSize={1}>{stepState.stepNumber}</Text>
        </Circle>
      )}
      <Label stepState={stepState}>
        <FormattedMessage {...stepState.step.title} />
      </Label>
    </StepDot>
    {!stepState.isLast && <StepLine isLast={stepState.isLast} />}
  </>
);

export default Step;
